import { GraphQLFormattedError } from 'graphql'
import Dialog from '../components/Dialog'

export type MutationHandlerError =
	| readonly GraphQLFormattedError[]
	| 'NETWORK_ERROR'
	| string
	| null
	| undefined
export type MutationHandlerSuccessResult = { success: true; errors: null }
export type MutationHandlerErrorResult = { success: false; errors: MutationHandlerError }
export type MutationHandlerResult = MutationHandlerSuccessResult | MutationHandlerErrorResult

export const handleMutationError = (operation: string, errors: MutationHandlerError): void => {
	// Leer bei Netzwerkfehlern: Die meldet schon der Apollo-Error-Link (client.tsx).
	if (!errors || errors.length === 0) {
		return
	}

	const errorCode = typeof errors === 'string' ? undefined : errors[0].extensions?.code
	const errorMessage = typeof errors === 'string' ? errors : errors[0].message

	console.error(`[mutation error] ${operation} (code=${String(errorCode)}): ${errorMessage}`, errors)

	// The server flags global errors (session expiry, maintenance, rate limit, unexpected server error);
	// the Apollo error link (client.tsx) surfaces them, so skip here to avoid a second dialog.
	if (typeof errors !== 'string' && errors[0].extensions?.global) {
		return
	}

	if (errorMessage === 'NETWORK_ERROR') {
		Dialog.render({
			title: 'Netzwerkfehler',
			description: 'Bitte überprüfe deine Internetverbindung und versuche es erneut.',
		})
		return
	}

	Dialog.render({
		title: `Fehler`,
		description: `${errorMessage}.`,
	})
}
